<div class="catalog-item-box">
  <app-product-image #productImage [height]="produtoHeight" [product]="product" [showStock]="false" [stock]="stock"
    [mostraPreco]="mostraPreco" [produtoDescrHeight]="produtoDescrHeight" (onAdd)="addCart($event)"
    (redirectTo)="redirectTo.emit($event)">
  </app-product-image>

  <div class="catalog-item-body">
    <div class="catalog-meta">
      <span class="ref"><span class="ref-label">REF:</span> {{ product.referencia }}</span>
      <span *ngIf="showStock && product.estoque > 0" class="estoque"><span class="estoque-label">ESTOQUE:</span> {{ stock }}</span>
      <span *ngIf="showStock && product.estoque == 0" class="estoque estoque-off" i18n>ESGOTADO</span>
      <span *ngIf="showStock && product.estoque < 0" class="estoque estoque-off" i18n>INDISPONÍVEL</span>
      <span *ngIf="!showStock && !product.estoque && SITE.mostraDisponivelCatalogo" class="estoque estoque-off" i18n>Indisponível</span>
    </div>

    <div class="descr" [style.min-height.px]="produtoDescrHeight" [style.font-size.rem]="produtoDescrFontSize"
      (click)="redirectTo.emit(product.id)">
      {{ product.descricao }}
    </div>

    <div class="catalog-item-footer">
      <div *ngIf="mostraPreco" class="catalog-price">
        <div *ngIf="product.precopromocional; else elseBlockPreco">
          <span i18n>De:</span>
          <span class="moneyOff" i18n>
            R${{ product.preco | currency : "BRL" : "" }}
          </span>
          <span i18n class="ml-2">Por:</span>
          <span class="money1 ml-1" i18n>R${{ product.precopromocional | currency : "BRL" : "" }}</span>
        </div>
        <ng-template #elseBlockPreco>
          <div>
            <span *ngIf="product.preco" class="money" i18n>R${{ getPrice() | currency : "BRL" : "" }}</span>
          </div>
          <div *ngIf="mostraPreco && product.precosugerido && userLogged" class="preco-sugerido">
            Preço sugerido: R${{ product.precosugerido | currency : "BRL" : "" }}
          </div>
        </ng-template>
      </div>
      <div class="product-quantity-input">
        <app-product-quantity-input *ngIf="product.preco" #productQuantityInput [product]="product"
          [produtoDescrHeight]="produtoDescrHeight" (onAdd)="addCart($event)" (redirectTo)="redirectTo.emit($event)">
        </app-product-quantity-input>
      </div>
    </div>
  </div>
  <!-- <div *ngIf="((mostraPreco && product.precosugerido) || showStock) && userLogged" class="row product-info-box"
    [style.backgroundColor]="SITE.backgroundColorSliderSuperior">
    <div *ngIf="mostraPreco && product.precosugerido" class="col-md-6">
      <span class="" [style.font-size.rem]="produtoIndispFontSize" i18n>Preço Sugerido<br />
        R${{ product.precosugerido | currency : "BRL" : "" }}
      </span>
    </div>
    <div *ngIf="showStock" class="col-md-6">
      <span *ngIf="this.product.estoque >= 0; else estoqueIndisponivel" [style.font-size.rem]="produtoIndispFontSize"
        i18n>Estoque<br />
        {{ stock }}
      </span>
      <ng-template #estoqueIndisponivel>
        <span *ngIf="validaEstoque; else naovalida" [style.font-size.rem]="produtoIndispFontSize" i18n>Indisponível
        </span>
        <ng-template #naovalida>
          <span [style.font-size.rem]="produtoIndispFontSize">{{
            config.descricao_estoque_indisponivel
            }}</span>
        </ng-template>
      </ng-template>
    </div>
  </div> -->
</div>